




import React, { useEffect, useRef, useState } from "react";
import Cloudbannerall from "./Cloudbannerall";
import Gelerycards from "./Gelerycards";
import NewFooter from "./NewFooter";
import Ourfoodcategery from "./Ourfoodcategery";
import Ourlandingpagedata from "./Ourlandingpagedata";
import Downloadapp from "./Downloadapp";
import Dealsoffer from '../Cloudkitchen/Dealsoffer.jsx';
import Digitalfoodall from '../Component/Digitalfood/Digitalfoodall.js'

const HomePage = ({ showLogin, setShowLogin, isSignup, setIsSignup, isLoggedIn }) => {
  const scrollContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  
  // ✅ Use local state for login tracking
  const [loginState, setLoginState] = useState(() => {
    // Check localStorage on initial load
    const token = localStorage.getItem("authToken");
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    return !!(token && loggedIn);
  });

  // ✅ Check login status from localStorage
  const checkLoginStatus = () => {
    const token = localStorage.getItem("authToken");
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    const newLoginState = !!(token && loggedIn);
    
    if (newLoginState !== loginState) {
      setLoginState(newLoginState);
    }
  };

  useEffect(() => {
  const interval = setInterval(() => {
    const token = localStorage.getItem("authToken");
    const loggedIn = !!(token && localStorage.getItem("isLoggedIn") === "true");
    
    if (loggedIn !== loginState) {
      setLoginState(loggedIn);
      console.log("Login state updated:", loggedIn);
    }
  }, 1000); // Check every second
  
  return () => clearInterval(interval);
}, [loginState]);

  // ✅ Listen for storage and custom events
  useEffect(() => {
    // Check on mount
    checkLoginStatus();
    
    // Listen for storage events (triggered by navbar)
    window.addEventListener('storage', checkLoginStatus);
    
    // Listen for custom event
    window.addEventListener('loginStatusChanged', checkLoginStatus);
    
    // Polling fallback (every 2 seconds)
    const interval = setInterval(checkLoginStatus, 2000);
    
    return () => {
      window.removeEventListener('storage', checkLoginStatus);
      window.removeEventListener('loginStatusChanged', checkLoginStatus);
      clearInterval(interval);
    };
  }, []);

  // ✅ Also sync with prop if needed
  useEffect(() => {
    if (isLoggedIn !== loginState) {
      setLoginState(isLoggedIn);
    }
  }, [isLoggedIn]);

  // ... rest of your scroll code ...

  return (
    <div style={styles.container}>
      <div style={{ marginTop: "20px", backgroundColor: "#faf9ff" }}>
        <div style={styles.pageContainer}>
          <div style={styles.bannerWrapper}>
           
            <Cloudbannerall />

          </div>
          {showMore && <div style={{ marginTop: "20px" }}></div>}
          {showGallery && <div style={{ marginTop: "20px" }}></div>}
        </div>

        {/* <Digitalfoodall
          setShowLogin={setShowLogin}
          setIsSignup={setIsSignup}
          isLoggedIn={loginState}  // ✅ Use loginState here
        /> */}

        {/* ✅ After login, this will hide automatically */}
        {/* {!loginState && (  // ✅ Use loginState instead of isLoggedIn */}
          <>
            <Ourlandingpagedata
              setShowLogin={setShowLogin}
              setIsSignup={setIsSignup}
              isLoggedIn={loginState}
            />
            <Downloadapp />
          </>
        {/* )} */}

        <NewFooter />
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    margin: 0,
    padding: 0,
    overflowX: "hidden",
  },
  pageContainer: {
    width: "100%",
  },
  bannerWrapper: {
    width: "100%",
  },
};

export default HomePage;